import styles from './PageRange.module.css';

type RangeProps = {
  currentPageRange: string;
  totalItems: number;
};

const PageRange = (props: RangeProps) => {
  return (
    <div className={styles.container}>
      <span>{props.currentPageRange}</span> of <span>{props.totalItems}</span>
    </div>
  );
};
export default PageRange;
